<template>
  <div class="factory">
    <nav-header :navs="5" :navsitems="16"/>
    <div class="contents">
      <div class="in-banner">
        <img
            src="../assets/img/caseitemplat.png"
            width="100%"
            height="auto"
        />
      </div>
      <transition>
        <div class="pageBox waps">
          <el-tabs v-model="activeName">
            <el-tab-pane label="公共建筑" name="first">
              <div class="gsjs clearfix animation srcospcur">
                <div class="Factorys-centers">
                  <div
                      class="Factorys-items"
                      v-for="(val, index) in comm_build.datalist"
                      :key="index"
                  >
                    <div class="factory_item" :title="val.title">
                      <div style="width: 100%;height: 160px;overflow: hidden">
                        <el-image v-if="val.image.indexOf('http') != -1"
                                  :src="val.image"
                                  style="width: 100%; height: auto"
                                  :preview-src-list="[val.image]"
                        />
                        <el-image v-else
                                  :src="`http://www.jiukaist.com${val.image}`"
                                  style="width: 100%; height: auto"
                                  :preview-src-list="[`http://www.jiukaist.com${val.image}`]"
                        />
                      </div>
                      <div class="layui-elip text">{{ val.title}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="el-pages">
                <el-pagination
                    background
                    @current-change="handleCurrentComm_build"
                    :current-page="comm_build.page"
                    :page-size="comm_build.pagesize"
                    layout="total,prev,pager,next"
                    :total="comm_build.total"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="医疗教育" name="second">
              <div class="gsjs clearfix animation srcospcur">
                <div class="Factorys-centers">
                  <div
                      class="Factorys-items"
                      v-for="(val, index) in medical_edu.datalist"
                      :key="index"
                  >
                    <div class="factory_item" :title="val.title">
                      <div style="width: 100%;height: 160px;overflow: hidden">
                        <el-image v-if="val.image.indexOf('http') != -1"
                                  :src="val.image"
                                  style="width: 100%; height: auto"
                                  :preview-src-list="[val.image]"
                        />
                        <el-image v-else
                                  :src="`http://www.jiukaist.com${val.image}`"
                                  style="width: 100%; height: auto"
                                  :preview-src-list="[`http://www.jiukaist.com${val.image}`]"
                        />
                      </div>
                      <div class="layui-elip text">{{ val.title}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="el-pages">
                <el-pagination
                    background
                    @current-change="handleCurrentMedical_edu"
                    :current-page="medical_edu.page"
                    :page-size="medical_edu.pagesize"
                    layout="total,prev,pager,next"
                    :total="medical_edu.total"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="工业制造" name="third">
              <div class="gsjs clearfix animation srcospcur">
                <div class="Factorys-centers">
                  <div
                      class="Factorys-items"
                      v-for="(val, index) in manufactur.datalist"
                      :key="index"

                  >
                    <div class="factory_item" :title="val.title">
                      <div style="width: 100%;height: 160px;overflow: hidden">
                        <el-image v-if="val.image.indexOf('http') != -1"
                                  :src="val.image"
                                  style="width: 100%; height: auto"
                                  :preview-src-list="[val.image]"
                        />
                        <el-image v-else
                                  :src="`http://www.jiukaist.com${val.image}`"
                                  style="width: 100%; height: auto"
                                  :preview-src-list="[`http://www.jiukaist.com${val.image}`]"
                        />
                      </div>
                      <div class="layui-elip text">{{ val.title}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="el-pages">
                <el-pagination
                    background
                    @current-change="handleCurrentManufactur"
                    :current-page="manufactur.page"
                    :page-size="manufactur.pagesize"
                    layout="total,prev,pager,next"
                    :total="manufactur.total"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </transition>
    </div>
    <nav-footer />
  </div>
</template>
<script>
import NavHeader from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
export default {
  name: "about",
  data() {
    return {
      //公共建筑
      comm_build:{
        page:1,
        pagesize:12,
        total:0,
        type:'27',
        datalist:[]
      },
      //医疗教育
      medical_edu:{
        page:1,
        pagesize:12,
        total:0,
        type:'29',
        datalist:[]
      },
      //工业制造
      manufactur:{
        page:1,
        pagesize:12,
        total:0,
        type:'31',
        datalist:[]
      },
      activeName: 'first'
    };
  },
  components: {
    NavHeader,
    NavFooter,
  },
  mounted() {},
  created() {
    let self = this;
    document.documentElement.scrollTop='0px'
    self.getDataList(this.comm_build);
    self.getDataList(this.medical_edu);
    self.getDataList(this.manufactur);
  },
  methods: {
    handleCurrentComm_build(val) {
      this.comm_build.page = val
      let self = this;
      self.getDataList(this.comm_build);
    },
    handleCurrentMedical_edu(val) {
      this.medical_edu.page = val
      let self = this;
      self.getDataList(this.medical_edu);
    },
    handleCurrentManufactur(val) {
      this.manufactur.page = val
      let self = this;
      self.getDataList(this.manufactur);
    },
    getDataList(param) {
      this.$api.mall
          .getExample({
            limit: param.pagesize,
            type:param.type,
            page: param.page,
          })
          .then((ress) => {
            let res = ress.data.data.data;
            param.datalist = res;
            param.total =  ress.data.data.total;
          });
    },
  },
};
</script>
<style lang="scss" scoped>
.factory {
  width: 100%;
  overflow: hidden;
  margin: 0px auto;
  .v-enter {
    opacity: 0;
    transform: translateY(150px);
  }
  .v-enter-active {
    transition: all 1s ease;
  }
  .contents {
    width: 100%;
    min-width: 1350px;
    overflow: hidden;
    margin: 0px auto;
    padding-top: 75px;
    .el-pages{
      width: 100%;
      margin: 20px auto;
      overflow: hidden;
      text-align: center;
    }
    .waps {
      width: 90%;
      max-width: 1200px;
      overflow: hidden;
      margin: 0 auto;
    }
    .pageBox {
      padding: 60px 0;
      .Factorys-centers {
        width: 100%;
        margin: 0px auto;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        .Factorys-items {
          width: 31%;
          overflow: hidden;
          position: relative;
          height: 220px;
          margin-left: 25px;
          margin-bottom: 30px;
          box-sizing: border-box;
          box-shadow: 0 0 10px 0 #ddd;
          .factory_item{
            cursor: pointer;
            padding: 15px;
            width: calc(100% - 30px);
            height: calc(100% - 30px);
          }
          .text {
            position: absolute;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            bottom: 15px;
            width: calc(100% - 30px);
            left: 15px;
            height: 38px;
            color: #fff;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.5);
            line-height: 38px;
          }
        }
      }
      .gsjs {
        transform: translate(0, 0px);
        opacity: 1;
        transition: 1.3s;
        -webkit-transition: 1.3s;
        .imgs {
          float: left;
          width: 420px;
          overflow: hidden;
        }
        .txts {
          float: right;
          width: calc(100% - 480px);
          line-height: 2em;
          font-family: 微软雅黑;
          font-size: 16px;
          color: #000000;
        }
        .txt {
          float: right;
          width: calc(100% - 480px);
          line-height: 1.5em;
        }
      }
      .pagetits {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        line-height: 1.2em;
        padding-bottom: 3%;
        color: #333333;
      }

      .pagetit {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        line-height: 1.2em;
        padding-bottom: 3.5%;
        color: #333333;
      }
    }
    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
    }
  }
  @media screen and (max-width:768px){
    .contents{
      padding-top: 60px!important;
      min-width: unset!important;
    }
    .waps{
      width: calc(100% - 30px)!important;
      max-width: unset!important;
    }
    .pageBox{
      padding: 15px 0!important;
    }
    .Factorys-items{
      width: 47%!important;
      height: 140px!important;
      margin-left: 10px!important;
      margin-bottom:15px!important;
    }
    .factory_item{
      padding: 10px!important;
      width: calc(100% - 20px)!important;
      height: calc(100% - 20px)!important;
    }
    .text{
      width: calc(100% - 20px)!important;
      left: 10px!important;
      bottom: 10px!important;
    }
  }
}
</style>
